import request from "utils/request";

export function loadBlogDetails(blogId) {
    return request()
        .get(`/api/v1/blog-details/${blogId}/`)
        .send();
}

export function getBlogDownload(blogId, formData) {
    return request()
        .post(`/api/v1/blog-details/${blogId}/`)
        .send(formData);
}

export function loadBlogPages() {
    return request()
        .get("/api/v1/video-blogs")
        .send();
}

export function loadBlogPage(blogId) {
    return request()
        .get(`/api/v1/video-blogs/${blogId}`)
        .send();
}

export function updateBlogPage(blogData) {
    const { id } = blogData;
    return request()
        .patch(`/api/v1/video-blogs/${id}/`)
        .send(blogData);
}

export function loadContactLists() {
    return request()
        .get("/api/v1/contact-lists/")
        .send()
}

export function cloneBlogPage(blogId) {
    return request()
        .get(`/api/v1/clone-blog/${blogId}/`)
        .send();
}

export function createBlogPage(blogData) {
    return request()
        .post(`/api/v1/video-blogs/`)
        .send(blogData);
}
